import { render, staticRenderFns } from "./laboratory-report.vue?vue&type=template&id=451ec004&scoped=true"
import script from "./laboratory-report.vue?vue&type=script&lang=js"
export * from "./laboratory-report.vue?vue&type=script&lang=js"
import style0 from "./laboratory-report.vue?vue&type=style&index=0&id=451ec004&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451ec004",
  null
  
)

export default component.exports